import { defineMessages, MessageDescriptor } from 'react-intl';

const messages: Record<string, MessageDescriptor> = defineMessages({
	en: {
		id: 'languages.english',
		defaultMessage: 'English'
	},
	de: {
		id: 'languages.german',
		defaultMessage: 'German'
	}
});

export default messages;
